import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/GoogleReviewButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/WhatsAppButton.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/tailwind.css");
